module.exports = __webpack_public_path__ + "appengine.icon.d44e5.svg";